import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { useAppState } from "../application/AppState";
import { Typography, Paper } from '@material-ui/core';
import useTranslation from "../application/translation";
import { formatDateAccordingToLanguage } from "../application/utils";
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';


const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    root: {
        "& > *": {
            borderBottom: "unset"
        }
    },
    pointer: {
        "&:hover": {
            cursor: "pointer"
        }
    },
    lightgray: {
        background: '#e6e6e6'
    }
});

const Payments = () => {
    const classes = useStyles();
    const [{ insurances, language }] = useAppState();
    const translation = useTranslation();
    const [openRow, setOpenRow] = React.useState("");

    return (
        <div>
            <Typography variant="body2">
                {translation.myins_payment_infotext}
            </Typography>
            <br />
           <TableContainer
            component={Paper}
            role="region"
            tabIndex={0}
            aria-label={translation.myins_payment_table_region}
            >
                <Table className={classes.table + ` insurance`} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>{translation.myins_docs_showhide}</TableCell>
                            <TableCell>{translation.myins_ins}</TableCell>
                            <TableCell align="left">{translation.myins_card}</TableCell>
                            <TableCell align="left">{translation.myins_fromdate}</TableCell>
                            <TableCell align="left">{translation.myins_todate}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {insurances.filter(ins => ins.insurancePayments.length > 0).map((insurance,index) => (
                            <Row key={index} row={insurance} language={language} open={insurance.policyType === openRow} onClick={(policyType) => setOpenRow(policyType)} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

function Row(props) {
    const { row, language } = props;
    const [openModule, setOpenModule] = React.useState(false);
    const classes = useStyles();
    const translation = useTranslation();

    return (
        <React.Fragment>
            <TableRow key={row.insuranceId} className={classes.root}>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpenModule(!openModule)}
                    >
                        {openModule ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row">{row.policyType}</TableCell>
                <TableCell align="left">{row.cardLoanName}</TableCell>
                <TableCell align="left">{formatDateAccordingToLanguage(row.startDate, language)}</TableCell>
                <TableCell align="left">{formatDateAccordingToLanguage(row.endDate, language)}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
                    <Collapse in={openModule} timeout="auto" unmountOnExit>
                        <Typography variant="caption" gutterBottom component="div">
                            {translation.myins_payment_header}
                        </Typography>
                        <Box sx={{ margin: 1 }}>
                            <Table className="insuranceInner" size="small" aria-label="insurance payments">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="right">{translation.myins_payment_amount}</TableCell>
                                        <TableCell align="left">{translation.myins_payment_fromdate}</TableCell>
                                        <TableCell align="left">{translation.myins_payment_todate}</TableCell>
                                        <TableCell align="right">{translation.myins_payment_days}</TableCell>
                                        <TableCell align="left">{translation.myins_payment_transdate}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row.insurancePayments?.map((insurancePayment, index) =>
                                        <TableRow key={`${row.insuranceId}${insurancePayment.paymentId}`} className={index % 2 === 0 ? classes.lightgrayNOT : ""}>
                                            <TableCell align="right">{insurancePayment.amount}</TableCell>
                                            <TableCell>{formatDateAccordingToLanguage(insurancePayment.fromDate, language)}</TableCell>
                                            <TableCell>{formatDateAccordingToLanguage(insurancePayment.toDate, language)}</TableCell>
                                            <TableCell align="right">{insurancePayment.days}</TableCell>
                                            <TableCell>{formatDateAccordingToLanguage(insurancePayment.transDate, language)}</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default Payments;